import { ItemAttachmentOpenFailure } from './previewSmimeAttachment.locstring.json';
import loc from 'owa-localize';
import loadSmimeItemAttachmentData from './loadSmimeItemAttachmentData';
import { DownloadSmimeAttachmentEventName } from '../datapoints';
import { logUsage } from 'owa-analytics';
import { isSmimeAttachmentType, TypeOfAttachment } from 'owa-attachment-model-store';
import getTypeOfAttachment from 'owa-attachment-model-store/lib/utils/getTypeOfAttachment';
import { ClientItemId } from 'owa-client-ids';
import { confirm } from 'owa-confirm-dialog';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

import { trace } from 'owa-trace';

/**
 * Utility to handle the preview of a S/MIME attachment.
 * For Item attachments, click should lead to a reading pane popout window containing item info.
 * @param attachment
 */
export default async function previewSmimeAttachment(
    attachment: AttachmentType,
    parentItemId: ClientItemId
): Promise<void> {
    try {
        if (isSmimeAttachmentType(attachment)) {
            const typeOfAttachment = getTypeOfAttachment(attachment);
            if (typeOfAttachment === TypeOfAttachment.Mail) {
                await loadSmimeItemAttachmentData(attachment, parentItemId);
                logUsage(DownloadSmimeAttachmentEventName, { typeOfAttachment });
                return;
            }
            throw new Error('Only mail S/MIME attachments can be previewed');
        } else {
            throw new Error(
                'previewSmimeAttachment should only be invoked for S/MIME decoded attachments'
            );
        }
    } catch (e) {
        trace.error('SmimeTraceError: ' + e.message);
        confirm('', loc(ItemAttachmentOpenFailure), false, {
            hideCancelButton: true,
        });
    }
}
